import { useTranslation } from 'react-i18next';
import React, {useState, useEffect, Fragment,useRef} from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import { TextField, Button, Grid, Typography, Box, MenuItem,Hidden,Table, TableContainer, TableCell, TableRow, TableBody, TableHead, IconButton, Checkbox, FormControlLabel} from '@mui/material';
import { useMessage } from "../../context/message-context";
import {pad} from "../../functions/default";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Refresh from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import Delete from '@mui/icons-material/Delete';
import {copy} from '../../functions/default';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { DateTextField } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import HelpIcon from '@mui/icons-material/Help'
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
function NewTimeCorrection(props) {
  const { t } = useTranslation();
  let { defaultdate } = useParams();
  const {client, accessToken} = props;
  const [date, setDate] = useState(defaultdate?defaultdate:(new Date(new Date().getTime() - 1000*60*60*24*1).getFullYear().toString()+'-'+pad(new Date(new Date().getTime() - 1000*60*60*24*1).getMonth()+1,2)+'-'+pad(new Date(new Date().getTime() - 1000*60*60*24*1).getDate(),2)));
  const [isLoading, setIsLoading] = useState(false);
  const [times, setTimes] = useState([{from: "00:00", to: "00:00", zeitart:"00"}]);
  const [defaultTimes, setDefaultTimes] = useState([{from: "00:00", to: "00:00"}]);
  const [comment, setComment] = useState('');
  const [form, setForm] = useState([]);
  const [invalidtext, setInvalidtext] = useState({});
  const navigate = useNavigate();
  const {hideMessage, showErrorMessage} = useMessage();
  const [pause,setPause]=useState("P");
  const [pausewert,setPauseWert]=useState("");
  const [regelung,setRegelung]=useState("00");
  const [anzeigeKappung,setAnzeigeKappung]=useState("")
  const [kappung,setKappung]=useState("")
  const [korrauswahl,setKorrauswahl]=useState("00");
  const [kauswahl,setKauswahl]=useState([]);
  const [fehler,setFehler]=useState("");
  const [optionen,setOptionen]=useState("0");
  const [info,setInfo]=useState("N");
  const [bemzwingen,setBemzwingen]=useState("0");
  const [bemerror,setBemerror]=useState(false);
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxOpenHinweis, setMessageBoxOpenHinweis] = useState(false);
  const [infoText,setInfoText]=useState(false)
  const [zeitarten,setZeitarten]=useState([])
  const twechsel=useRef(0)
  /*useEffect(() => {
    if (defaultdate) {
      if (defaultdate.length === 10) {
        setDate(defaultdate);
      }
    }
  }, [defaultdate])*/
 /* useEffect(() => {
    if (date !== '') {
      const year = parseInt(date.slice(0,4));
      if (year < 1990) {
        setIsLoading(true);
        return
      }
      setIsLoading(true);
      const payload={
        "mandant": client, // this.props.client,
        "program": "PZKOA0",
        "statement": "LADE_ZEIT",
        "date": date.slice(0,4)+date.slice(5,7)+date.slice(8,10)
      }
      const headers={
        "Authorization": "Bearer "+accessToken,
      }
      apiRequest('POST', 'daten', payload, headers, tableCb);  
    } else {
      setIsLoading(true);
    }
    // eslint-disable-next-line
  }, [date]);*/
  useEffect(() => {
    setIsLoading(true);
    if (date !== '') {
      const year = parseInt(date.slice(0,4));
      if (year < 1990) {
        setIsLoading(false);
        return
      }
      const payload={
        "mandant": client, // this.props.client,
        "program": "PZKOA0",
        "statement": "LADE_ZEIT",
        "date": date.slice(0,4)+date.slice(5,7)+date.slice(8,10)
      }
      const headers={
        "Authorization": "Bearer "+accessToken,
      }
      apiRequest('POST', 'daten', payload, headers, tableCb);  
    } else {
      setIsLoading(false);
    }
    // eslint-disable-next-line
  }, [date]);
  useEffect(() => {
    setBemerror(false)
    // eslint-disable-next-line
  }, [comment]);
  const insert=(row)=>{
    var array=[...times.slice(0,row),{from: "00:00", to: "00:00", zeitart:"00"},...times.slice(row)]
    setTimes(array);
  }
  const addRow = () => {
    const array = times.slice()
      array.push({from: "00:00", to: "00:00", zeitart:"00"});
    setTimes(array);
  }
  const delRow=(row)=>{
    var array=[...times]
    if (array.length<2) return  
    array.splice(row,1)
    setTimes(array);
  }
  const tableCb = (response) => {
    setFehler(response.data.message);
    setInfo(response.data.antrag);
    if (response.status === 200) {
         setOptionen(response.data.optionen);
         if (response.data.zeitarten){
           setZeitarten(response.data.zeitarten)
         }
         if (response.data.anzeige_kappung){
          setAnzeigeKappung(response.data.anzeige_kappung)
        }
         if (response.data.bemzwingen) setBemzwingen(response.data.bemzwingen);
         if (response.data.antrag==="V"){
          if (response.data.zeitdaten) setTimes(response.data.zeitdaten);
          if (response.data.times) setDefaultTimes(response.data.times);
          if (response.data.pause) setPause(response.data.pause);
          if (response.data.pausewert) setPauseWert(response.data.pausewert);
          if (response.data.regelung)setRegelung(response.data.regelung);
          if (response.data.kappung)setKappung(response.data.kappung);
          if (response.data.korr) setKorrauswahl(response.data.korr);
          if (response.data.comment) setComment(response.data.comment);
          
        }else {
      if (response.data.times) {
        setTimes(response.data.times);
        setDefaultTimes(response.data.times);
      }else{
        setTimes([{from: "00:00", to: "00:00", zeitart:"00"}]);
        setDefaultTimes([{from: "00:00", to: "00:00"}]);
      }}
      setKauswahl(response.data.korr_auswahl);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
    setIsLoading(false);
  }
  const formSubmitCb = (response) => {
    if (response.status === 200) {
      navigate(-1);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
        setForm(response.data.form);
        setInvalidtext(response.data.invalidtext);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const onSubmit = (e) => {
    if ((comment===false||comment==="")&&bemzwingen==="1") {
      setBemerror(true);
      return
    } else {
      setBemerror(false);
    }
    
    if (twechsel.current===1){
      var pretime="00:00"
      var posttime="00:00"
      var wechsel=0
      defaultTimes.forEach((item,index)=>{
        if (item.to.replace(":","")<item.from.replace(":","")) {wechsel=1}
        if (defaultTimes.length===1&&(!item.from||item.from==="00:00")&&(!item.to||item.to==="00:00")){
          wechsel=2
        }
        if (((!pretime||pretime==="00:00")&&(!posttime||posttime==="00:00"))===false&&((!item.from||item.from==="00:00")&&(!item.to||item.to==="00:00"))===false){
          if (item.from.replace(":","")<pretime.replace(":","")){
            wechsel=1
          }
        }
      
      pretime=item.from
      posttime=item.to
      if (!pretime) pretime="00:00"
      if (!posttime) posttime="00:00"
      })
      
      if (wechsel===0){
        setMessageBoxOpenHinweis(true);
        return
      }
    }
    e.preventDefault();
    e.stopPropagation();
    sendAntrag()    
  }
  function  sendAntrag(){
    console.log(kappung)
    const payload={
      "mandant": client,
      "program": "PZKOA0",
      "statement": "NEUER_ANTRAG",
      "items": times,
      "date": date.slice(0,4)+date.slice(5,7)+date.slice(8,10),
      "comment": comment,
      "pause": pause,
      "pausewert": pausewert,
      "regelung": regelung,
      "korrauswahl": korrauswahl,
      "kappung": kappung,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, formSubmitCb);
  }
  const messageBoxResult = (result) => {
    setMessageBoxOpen(false);
    if (result === 'YES') {
      setIsLoading(true);
      const payload={
        "mandant": client,
        "program": "PZKOA0",
        "statement": "AKTION",
        "absence": date.slice(0,4)+date.slice(5,7)+date.slice(8,10),
        "aktion": "ZURUECK",
      }
      const headers={
        "Authorization": "Bearer "+accessToken,
      }
      apiRequest('POST', 'daten', payload, headers, useraktionCB);  
    }
  }
  const messageBoxHinweisResult = (result) => {
    setMessageBoxOpenHinweis(false);
    if (result === 'YES') {
      twechsel.current=0
      sendAntrag()
    }
  }
  const userAktion = (aktion) => {
  if (aktion==="STORNO"){
    setMessageBoxOpen(true);
    return
  }
    
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "PZKOA0",
      "statement": "AKTION",
      "absence": date.slice(0,4)+date.slice(5,7)+date.slice(8,10),
      "aktion": aktion,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, useraktionCB);
  }
  
  const useraktionCB = (response) => {
    if (response.status === 200) {
        if (response.data.message==="OK"){
        setIsLoading(false);
        hideMessage();
        navigate(-1);   
      }else {
        showErrorMessage(response.data.message);
      }
  
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }  
  }
  const renderOrig=()=>{
      return(
          <Grid container justifyContent="center" spacing={2}>
          <Grid item lg={4} md={8} xs={12}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center" colSpan={3}>
                    {t("Originalzeiten")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                
          {defaultTimes.map((rows,tcount)=>(
            <TableRow>
              <TableCell align="center">
              {rows.from}
              </TableCell>
              <TableCell align="center">
              {"-"}
              </TableCell>
              <TableCell align="center">
              {rows.to}
              </TableCell>
            </TableRow>
          ))}
          </TableBody>
          </Table>
          </TableContainer>
          </Grid>
          </Grid>
      ); 
  }
  const renderForm = () => {
    var errorfrombool = false;
    var errorfromtext = '';
    var errortobool = false;
    var errortotext = '';
    var pretime="00:00"
    var posttime="00:00"
    var tageswechsel=0
    twechsel.current=0
    var nextday=new Date(date)
    nextday.setDate(nextday.getDate()+1)
    var nextdaytext=pad(nextday.getDate(),2)+"."+pad(nextday.getMonth()+1,2)+"."+nextday.getFullYear()
    const formObjects = times.map((rows, tcount) => {
      try {
        errorfrombool = form.vonzeit[tcount].valid === "false";
        errorfromtext = invalidtext.vonzeit[tcount].valid;
        errortobool = form.biszeit[tcount].valid === "false";
        errortotext = invalidtext.biszeit[tcount].valid;
      } catch (error) {
        errorfrombool = false;
        errorfromtext = '';
        errortobool = false;
        errortotext = '';        
      }
      if (tageswechsel===1) tageswechsel=2
      if (tageswechsel<1){
        if (((!pretime||pretime==="00:00")&&(!posttime||posttime==="00:00"))===false&&((!rows.from||rows.from==="00:00")&&(!rows.to||rows.to==="00:00"))===false){
          if (rows.from.replace(":","")<pretime.replace(":","")){
            tageswechsel=1
            twechsel.current=1
          }
        }
      }
      
      pretime=rows.from
      posttime=rows.to
      if (!pretime) pretime="00:00"
      if (!posttime) posttime="00:00"
        return(
          <>
          {tageswechsel===1&&
          <Grid item xs={12}>
            <hr align="center" width="100%" height="2px"/>
            {"Tageswechsel erkannt – Nachfolgende Zeiten gehören zum "+nextdaytext}
            <IconButton 
              color="primary"
              size="small"
              onClick={()=>setInfoText(true)}
            >
              <HelpIcon fontSize="small"/>
            </IconButton >
            <hr align="center" width="100%" height="2px"/>
        
          </Grid>
          }
          <Grid item xs={12} sm={12} lg={2}>
          <Button
                id="addRow"
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => insert(tcount)}
              >
                {t("Hinzufügen")}
              </Button>     
              </Grid>
              <Grid item xs={12} sm={12} lg={8}>
                <Grid container>
              <Grid item xs={12} sm={zeitarten&&zeitarten.length>0?4:6} lg={zeitarten&&zeitarten.length>0?4:6}>
          <TextField
                id={"iv"+tcount.toString()}
                key={"iv"+tcount.toString()}
                onChange={(e) => {onChangeTime(e, tcount, "v")}}
                label={t("Von")}
                type="time"
                fullWidth
                error={errorfrombool}
                helperText={errorfromtext}
                value={rows.from}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
              />
          </Grid>
          <Grid item xs={12} sm={zeitarten&&zeitarten.length>0?4:6} lg={zeitarten&&zeitarten.length>0?4:6}>
            <TextField
                id={"ib"+tcount.toString()}
                key={"ib"+tcount.toString()}
                onChange={(e) => {onChangeTime(e, tcount, "b")}}
                label={t("Bis")}
                type="time"
                error={errortobool}
                helperText={errortotext}
                fullWidth
                value={rows.to}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 min
                }}
              />
              </Grid>
            {zeitarten&&zeitarten.length>0&&
            <Grid item xs={12} sm={4} lg={4}>
              <TextField
                id={"za"+tcount.toString()}
                key={"za"+tcount.toString()}
                onChange={(e) => {onChangeTime(e, tcount, "z")}}
                label={t("Zeitart")}
                fullWidth
                value={rows.zeitart}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                select
              >
                {zeitarten.map((item, index) => (
                  <MenuItem key={index} value={item.key}>{item.bez}</MenuItem>
                 ))}
              </TextField>
              </Grid>
              
            }
            </Grid>
            </Grid>
              {times.length>1&&
              <Grid item xs={12} sm={12} lg={2}>
                <Button
                id="delRow"
                fullWidth
                variant="contained"
                
                color="primary"
                startIcon={<Delete />}
                onClick={() => delRow(tcount)}
              >
                {t("Entfernen")}
              </Button>        
              </Grid>
              }
          
          </>
        );
    });
    return formObjects;
  }
  const onChangeTime = (e, key, vb) => {
    const updateTimes = times.slice();
    var updateTime = updateTimes[key];
    var fr = "";
    var to = "";
    var za = "00";
    if (updateTime) {
      fr = updateTime.from;
      to = updateTime.to;
      za = updateTime.zeitart;
      if (updateTime.to !== "") {
      }
    }
    if (vb === "v") {
      fr = e.target.value
    } else if (vb === "b"){
      to = e.target.value
    } else {
      za = e.target.value
    }
    updateTimes[key] = {from: fr, to: to, zeitart:za,};
    console.log('updateTime',updateTimes[key]);
    setTimes(updateTimes);
  }
  if (isLoading) {
    return <LoadingComponent />
  }
 
return (
  <Box p={1}>
    <Hidden mdDown>
      <Typography color="primary" variant="h5">{t("Neuer Korrekturantrag")}</Typography>
    </Hidden>
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={10} lg={8}>
      <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
      
        <Grid item xs={12} >
          <DateTextField 
            disabled={defaultdate}
            label={t("Datum")}
            variant="outlined"
            value={date}
            onChange={(event) => setDate(event.target.value)}
            InputLabelProps={{
             shrink: true,
            }}
          />
        </Grid>
        {info==="V"  &&
        <Grid item xs={12} >
          <Typography>
            {t("Für das ausgewählte Datum existiert bereits ein gestellter Antrag, dieser kann bearbeitet werden.")}
          </Typography>
        </Grid>
          }
        {info==="E" &&
        <Grid item xs={12} >
          <Typography>
            {t("Für das ausgewählte Datum existiert bereits ein erledigter Antrag. Für Änderungen stornieren Sie bitte diesen und stellen einen neuen Antrag.")}
          </Typography>
        </Grid>
        }   
        {fehler==="OK"&&
        
         <Fragment>
           {renderOrig()}
           {renderForm()}
         <Grid item xs={12} sm={6}>
            {((times&&times.length>0)&&(times[times.length-1].from !== "00:00" || times[times.length-1].to !== "00:00")) &&  
              <Button
                id="add"
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => addRow()}
              >
                {t("Neue Zeile Hinzufügen")}
              </Button>        
            }
          </Grid>
          <Grid item xs={12} sm={6}> 
           
            <Button
              fullWidth
              color="primary"
              startIcon={<Refresh />}
              onClick={() => setTimes(copy(defaultTimes))}
            >
              {t("Zurücksetzen (Auf Originalzeiten)")}
            </Button> 
 
          </Grid>
            {(optionen==="0" ||optionen==="1" )&&
          <Grid item xs={12}>
            <TextField
                select
                variant="outlined"
                fullWidth
                label={t("Erweiterter Arbeitszeitrahmen")}
                margin="normal"
                value={regelung}
                onChange={(event) => setRegelung(event.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              >
              <MenuItem value="00">{t("Rahmen laut Plan")}</MenuItem>
              <MenuItem value="10">{t("Vorarbeit")}</MenuItem>
              <MenuItem value="01">{t("Nacharbeit")}</MenuItem>
              <MenuItem value="11">{t("Vor- und Nacharbeit")}</MenuItem>                  
            </TextField> 
          </Grid>
}
{(optionen==="0" ||optionen==="2" )&&
          <Grid item xs={12}>
            <TextField
                select
                variant="outlined"
                label={t("Abweichende Pause")}
                fullWidth
                margin="normal"
                value={pause}
                onChange={(event) => setPause(event.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              >
              <MenuItem value="M">{t("Manuelle Vorgabe")}</MenuItem>
              <MenuItem value="K">{t("Kein Pausenabzug")}</MenuItem>
              <MenuItem value="P">{t("Pause laut Plan")}</MenuItem>
            </TextField> 
          </Grid>
}
          {  (pause==="M"&&((optionen==="0" ||optionen==="2" )) )&&
            <Grid item xs={12}>
              <TextField
                  type="time"
                  variant="outlined"
                  label={t("Abweichende Pause")}
                  fullWidth
                  margin="normal"
                  value={pausewert}
                  onChange={(event) => setPauseWert(event.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
              </TextField> 
            </Grid>
          }
          {(anzeigeKappung==="J")&&
              <Grid item xs={12}>
                  <FormControlLabel
                      control={
                          <Checkbox
                              checked={kappung==="1"}
                              onChange={(e)=>(e.target.checked)?setKappung("1"):setKappung("")}
                          />}
                      label={"Kappung freigeben"}
                      InputLabelProps={{
                        shrink: true,
                      }}
                  />
              </Grid>
          }
          {  ( (kauswahl)&&kauswahl.length>1) &&
              <Grid item xs={12}>
              <TextField
                select
                variant="outlined"
                label={t("Vergütungsart")}
                fullWidth
                margin="normal"
                value={korrauswahl}
                onChange={(event) => setKorrauswahl(event.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
            >
            {  kauswahl.map((eintrag)=> {
               return(
                  <MenuItem value={eintrag.key}>{eintrag.bez}</MenuItem>
               )
              })
            }
            </TextField>
            </Grid>
          }         
            <Grid item xs={12} >
              <TextField
                id={"comment"}
                key={"comment"}
                value={comment}
                onChange={(e) => {setComment(e.target.value)}}
                label={t("Kommentar")}
                fullWidth
                error={bemerror}
                helperText={bemerror&&"Bitte geben Sie einen Grund ein"}
                multiline
                rows={3}
                variant="outlined"
              />
            </Grid>
          {info!=="V"&&
          <Grid item xs={12} sm={6}>  
            <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<CloseIcon />}
                onClick={() => navigate(-1)}
              >
                {t("Abbrechen")}
             </Button>
          </Grid>
          }
          {info==="V"&&
            <Grid item xs={12} sm={6}>  
            <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<CloseIcon />}
                onClick={() => userAktion("STORNO")}
              >
                {t("Antrag zurückziehen")}
             </Button>
          </Grid>
          }
          
          <Grid item xs={12} sm={6} paddingBottom={{xs:12,md:0}} >      
            <Button
                fullWidth
                variant="contained"
                color="primary"
                startIcon={<DoneIcon />}
                onClick={onSubmit} 
                key="submit"
              >
                {t("Antrag absenden")}
              </Button>
          </Grid>
          
         
     </Fragment>  
}
    </Grid>                     
    </Grid>
  </Grid>
  <MessageBox 
    open={messageBoxOpen}
    handleResponse={messageBoxResult}
    buttons="YESNO"
    text={t("Wollen Sie den Antrag wirklich zurückziehen?")}
    title={t("Achtung")}
  />
  <MessageBox 
    open={messageBoxOpenHinweis}
    handleResponse={messageBoxHinweisResult}
    buttons="YESNO"
    text={"Haben Sie wirklich über Nacht gearbeitet?\n\nDurch die Eingabe Ihrer Zeiten haben Sie dem System signalisiert, dass ein Tageswechsel stattfinden muss.Ihre gebuchten (Original-)Zeiten deuten aber nicht darauf hin.\n\nSollen die Zeiten trotzdem wie angegeben abgesendet werden?".split("\n")}
    title={t("Achtung")}
  />
  <ResponsiveDialog 
    title={t("Hinweis Tageswechsel")}
    open={infoText} 
    setOpen={(o)=>setInfoText(false)}
  >
    <Box p={2}>
      <Typography>
      {t("Das System erwartet die Eingabe der Arbeitszeiten in chronologischer Reihenfolge – d.h. in exakt derselben Reihenfolge wie Sie diese auch gearbeitet haben.")}
      <br/>
      {t("Dadurch werden Arbeitszeiten mit einer niedrigeren Uhrzeit dem Folgetag zugeordnet, falls sie nach Arbeitszeiten mit einer höheren Uhrzeit erfasst werden.")}
      <br/>
      <br/>
      {t("Beispiel:")}
      <br/>
      {t("Korrekturen für den 01.06.")}
      <br/>
      {t("Zeile 1   12:00 – 20:00 Uhr")}
      <br/>
      {t("Zeile 2   3:00 – 5:00 Uhr (ein Tageswechsel wird erkannt und die Zeiten werden dem Folgetag – in diesem Fall dem 02.06. zugeordnet)")}
      <br/>
      <br/>
      {t("Wenn die Zeiten in der umgekehrten Reihenfolge erfasst werden, werden beide Zeiten dem ausgewählten Tag (01.06.) zugeordnet:")}
      <br/>
      {t("Zeile 1   3:00 – 5:00 Uhr")}
      <br/>
      {t("Zeile 2   12:00 – 20:00 Uhr")}
      <br/>
      <br/>
      {t("Bitte erfassen Sie Ihre Zeiten daher immer in der tatsächlichen Reihenfolge, damit das System die richtige Zuordnung vornehmen kann.")}
      </Typography>
    </Box>
  </ResponsiveDialog>
</Box>
)
              }
export default NewTimeCorrection;
